import { roleConstants, alertConstants } from '../_constants'

const initialState = {
    roleList: [],
    isRoleLoading: false,
    isGetAllError: false,
}
export function role(state = { ...initialState }, action) {
    switch (action.type) {
        case alertConstants.CLEAR:
            return {
                ...state,
            }
        case roleConstants.GETALL_REQUEST:
            return {
                ...state,
                isRoleLoading: true,

            }
        case roleConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error,
                isRoleLoading: false,
                isGetAllError: true,
                roleList: [],

            }
        case roleConstants.GETALL_SUCCESS:
            return {
                ...state,
                isRoleLoading: false,
                roleList: action.role,
            }
        default:
            return state
    }
}
